// extracted by mini-css-extract-plugin
export default {"header":"users_header__fHX1q","search":"users_search__-9CT6","pagination":"users_pagination__vutcy","spin":"users_spin__kPDyd"};